export const SET_PERMISSION = 'set-permission';
export const CLEAR_PERMISSION = 'clear-permission';
